import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import CustomData from "pages/_components/CustomData/CustomData";
import I18n from "pages/_components/I18n";
import * as i18n from "util/i18n";
import { actions as cedipActions } from "reducers/cedip";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import CedipConfirmationBody from "./CedipConfirmationBody";

const CedipConfirmation = () => {
    const { state = { idActivity: "transmit.cedip.send", idTitle: "cedip.transmit" } } = useLocation();
    const { idActivity, idTitle } = state;

    const { transmitCedipData, cedipTicket, selectedActionCedip } = useSelector((_state) => _state.cedip);
    useConfirmTransaction(transmitCedipData, cedipTicket, "cedip/transmit");

    const renderMessageInfo = () => (
        <>
            <div className="container--alert" role="alert">
                <div className="alert alert-info">
                    <CustomData
                        icon="information_fill.svg"
                        titleText="cedip.transmit.confirm.info"
                        titleTextType="I18N"
                        keepSpaceIfNoValue={false}
                    />
                </div>
            </div>
        </>
    );

    return (
        <>
            <Notification scopeToShow="/cedip/transmit/confirm" />
            <ResponsiveHeader id={idTitle} />
            <MainContainer>
                <div className="container transaction-ticket">
                    <h2>
                        <I18n id="cedip.solicitSummary.confirm" />
                    </h2>
                    <div className="ticket">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <CedipConfirmationBody
                                idAccount={transmitCedipData?.idAccount || transmitCedipData?.idAccountReceived}
                                beneficiary={transmitCedipData.beneficiary}
                                amount={transmitCedipData.amount}
                                selectedActionCedip={selectedActionCedip}
                            />
                            <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                        </div>
                    </div>
                    {selectedActionCedip === "CEDIP-TRANSMIT" && renderMessageInfo()}
                    <GeneralCredentialForm
                        transactionData={transmitCedipData}
                        action={cedipActions.actionCedip}
                        idActivity={idActivity}
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default CedipConfirmation;
